export const pluginID = 'security';

export const configurableActions = [
  'accountSalesCreditLimit',
  'reducedAmount',
  'rowRemoval',
  'startNewSale',
] as const;
